import { NavItem } from '../../vertical-sidebar/menu-list-item/nav-item';

export const navItems: NavItem[] = [
  {
    navCap: 'Home',
  },
  {
    displayName: 'Dashboards',
    iconName: 'home',
    route: '/dashboards',
    children: [
      {
        displayName: 'Analytical',
        iconName: 'pie-chart',
        route: 'dashboards/dashboard1',
      },
      {
        displayName: 'eCommerce',
        iconName: 'shopping-bag',
        route: 'dashboards/dashboard2',
      },
      {
        displayName: 'Modern',
        iconName: 'inbox',
        route: 'dashboards/dashboard3',
      },
    ],
  },
  {
    navCap: 'Apps',
  },
  {
    displayName: 'Apps',
    iconName: 'grid',
    route: '/apps',
    ddType: "two-column",
    children: [
      {
        displayName: 'Chat',
        iconName: 'message-square',
        route: 'apps/chat',
      },
      {
        displayName: 'Calendar',
        iconName: 'calendar',
        route: 'apps/calendar',
      },
      {
        displayName: 'MailBox',
        iconName: 'mail',
        route: 'apps/mailbox/inbox',
      },
      {
        displayName: 'Contacts',
        iconName: 'user',
        route: 'apps/contacts',
      },
      {
        displayName: 'Courses',
        iconName: 'gitlab',
        route: 'apps/courses',
      },
      {
        displayName: 'Employee',
        iconName: 'user',
        route: 'apps/employee',
      },
      {
        displayName: 'Notes',
        iconName: 'file',
        route: 'apps/notes',
      },
      {
        displayName: 'Tickets',
        iconName: 'flag',
        route: 'apps',
        children: [
          {
            displayName: 'Ticket Listing',
            iconName: 'disc',
            route: 'apps/tickets',
          },

          {
            displayName: 'Ticket Detail',
            iconName: 'disc',
            route: 'apps/ticketdetails',
          },
        ],
      },
      {
        displayName: 'ToDo',
        iconName: 'check',
        route: 'apps/todo',
      },
      {
        displayName: 'Taskboard',
        iconName: 'check-circle',
        route: 'apps/taskboard',
      },
      {
        displayName: 'Permissions',
        iconName: 'lock',
        route: 'apps/permission',
      },
    ],
  },
  {
    navCap: 'Ui',
  },
  {
    displayName: 'Ui',
    iconName: 'archive',
    route: 'ui-components',
    ddType: "mega-menu",
    children: [
      {
        displayName: 'Badge',
        iconName: 'disc',
        route: 'ui-components/badge',
      },
      {
        displayName: 'Buttons',
        iconName: 'disc',
        route: 'ui-components/buttons',
      },
      {
        displayName: 'Cards',
        iconName: 'disc',
        route: 'ui-components/cards',
      },
      {
        displayName: 'Chips',
        iconName: 'disc',
        route: 'ui-components/chips',
      },
      {
        displayName: 'Dialog',
        iconName: 'disc',
        route: 'ui-components/dialog',
      },
      {
        displayName: 'Expansion',
        iconName: 'disc',
        route: 'ui-components/expansion',
      },
      {
        displayName: 'Grid',
        iconName: 'disc',
        route: 'ui-components/grid',
      },
      {
        displayName: 'Lists',
        iconName: 'disc',
        route: 'ui-components/lists',
      },
      {
        displayName: 'Menu',
        iconName: 'disc',
        route: 'ui-components/menu',
      },
      {
        displayName: 'Progress',
        iconName: 'disc',
        route: 'ui-components/progress',
      },
      {
        displayName: 'Progress Snipper',
        iconName: 'disc',
        route: 'ui-components/progress-snipper',
      },
      {
        displayName: 'Ripples',
        iconName: 'disc',
        route: 'ui-components/ripples',
      },
      {
        displayName: 'Slide Toggle',
        iconName: 'disc',
        route: 'ui-components/slide-toggle',
      },
      {
        displayName: 'Slider',
        iconName: 'disc',
        route: 'ui-components/slider',
      },
      {
        displayName: 'Snackbar',
        iconName: 'disc',
        route: 'ui-components/snackbar',
      },
      {
        displayName: 'Stepper',
        iconName: 'disc',
        route: 'ui-components/stepper',
      },
      {
        displayName: 'Tabs',
        iconName: 'disc',
        route: 'ui-components/tabs',
      },
      {
        displayName: 'Toolbar',
        iconName: 'disc',
        route: 'ui-components/toolbar',
      },
      {
        displayName: 'Tooltip',
        iconName: 'disc',
        route: 'ui-components/tooltip',
      },
    ],
  },
  {
    navCap: 'Forms',
  },
  {
    displayName: 'Forms',
    iconName: 'file-text',
    route: 'forms',
    children: [
      {
        displayName: 'Form Elements',
        iconName: 'package',
        route: 'forms',
        children: [
          {
            displayName: 'Autocomplete',
            iconName: 'disc',
            route: 'forms/autocomplete',
          },
          {
            displayName: 'Checkbox',
            iconName: 'disc',
            route: 'forms/checkbox',
          },
          {
            displayName: 'Datepicker',
            iconName: 'disc',
            route: 'forms/datepicker',
          },
          {
            displayName: 'Editor',
            iconName: 'disc',
            route: 'forms/editor',
          },
          {
            displayName: 'Form Field',
            iconName: 'disc',
            route: 'forms/form-field',
          },
          {
            displayName: 'Input',
            iconName: 'disc',
            route: 'forms/input',
          },
          {
            displayName: 'Paginator',
            iconName: 'disc',
            route: 'forms/paginator',
          },
          {
            displayName: 'Radio',
            iconName: 'disc',
            route: 'forms/radio-button',
          },
          {
            displayName: 'Select',
            iconName: 'disc',
            route: 'forms/select',
          },
          {
            displayName: 'Sort Header',
            iconName: 'disc',
            route: 'forms/sort-header',
          },
        ],
      },
      {
        displayName: 'Tree',
        iconName: 'git-pull-request',
        route: 'tree',
        children: [
          {
            displayName: 'Dynamic Tree',
            iconName: 'disc',
            route: 'tree/dynamic-tree',
          },
          {
            displayName: 'Flat Tree',
            iconName: 'disc',
            route: 'tree/flat-tree',
          },
          {
            displayName: 'Load Tree',
            iconName: 'disc',
            route: 'tree/load-tree',
          },
          {
            displayName: 'Nested Tree',
            iconName: 'disc',
            route: 'tree/nested-tree',
          },
        ]
      },
      {
        displayName: 'Form Layouts',
        iconName: 'clipboard',
        route: 'forms/form-layouts',
      },
      {
        displayName: 'Form Wizard',
        iconName: 'columns',
        route: 'forms/wizard',
      },
      {
        displayName: 'Form Validation',
        iconName: 'check-square',
        route: 'forms/form-validation',
      },
    ],
  },
  {
    navCap: 'Tables',
  },
  {
    displayName: 'Tables',
    iconName: 'layout',
    route: '',
    children: [
      {
        displayName: 'Basic Tables',
        iconName: 'layout',
        route: 'tables',
        children: [
          {
            displayName: 'Basic Table',
            iconName: 'disc',
            route: 'tables/basic-table',
          },
          {
            displayName: 'Dynamic Table',
            iconName: 'disc',
            route: 'tables/dynamic-table',
          },
          {
            displayName: 'Expand Table',
            iconName: 'disc',
            route: 'tables/expand-table',
          },
          {
            displayName: 'Filterable Table',
            iconName: 'disc',
            route: 'tables/filterable-table',
          },
          {
            displayName: 'Footer Row Table',
            iconName: 'disc',
            route: 'tables/footer-row-table',
          },
          {
            displayName: 'HTTP Table',
            iconName: 'disc',
            route: 'tables/http-table',
          },
          {
            displayName: 'Mix Table',
            iconName: 'disc',
            route: 'tables/mix-table',
          },
          {
            displayName: 'Multi Header Footer',
            iconName: 'disc',
            route: 'tables/multi-header-footer-table',
          },
          {
            displayName: 'Pagination Table',
            iconName: 'disc',
            route: 'tables/pagination-table',
          },
          {
            displayName: 'Row Context Table',
            iconName: 'disc',
            route: 'tables/row-context-table',
          },
          {
            displayName: 'Selection Table',
            iconName: 'disc',
            route: 'tables/selection-table',
          },
          {
            displayName: 'Sortable Table',
            iconName: 'disc',
            route: 'tables/sortable-table',
          },
          {
            displayName: 'Sticky Column',
            iconName: 'disc',
            route: 'tables/sticky-column-table',
          },
          {
            displayName: 'Sticky Header Footer',
            iconName: 'disc',
            route: 'tables/sticky-header-footer-table',
          },
        ],
      },
      {
        displayName: 'Datatables',
        iconName: 'database',
        route: 'datatables',
        children: [
          {
            displayName: 'Basic DataTable',
            iconName: 'disc',
            route: 'datatables/basic-datatable',
          },
          {
            displayName: 'Material Table',
            iconName: 'disc',
            route: 'datatables/material-table',
          },
          {
            displayName: 'Table Editing',
            iconName: 'disc',
            route: 'datatables/table-editing',
          },
          {
            displayName: 'Filter Table',
            iconName: 'disc',
            route: 'datatables/table-filter',
          },
        ],
      },
    ],
  },
  {
    navCap: 'Pages',
  },
  {
    displayName: 'Pages',
    iconName: 'book-open',
    route: '',
    children: [
      {
        displayName: 'Material Icon',
        iconName: 'feather',
        route: 'sample-pages/material',
      },
      {
        displayName: 'Timeline',
        iconName: 'clock',
        route: 'sample-pages/timeline',
      },
      {
        displayName: 'Invoice',
        iconName: 'file-text',
        route: 'sample-pages/invoice',
      },
      {
        displayName: 'Pricing',
        iconName: 'dollar-sign',
        route: 'sample-pages/pricing',
      },
      {
        displayName: 'Helper Class',
        iconName: 'aperture',
        route: 'sample-pages/helper',
      },
      {
        displayName: 'Apex Chart',
        iconName: 'bar-chart',
        route: 'charts/apex-chart',
      },
    ],
  },
  {
    navCap: 'Multi DD',
  },
  {
    displayName: 'Menu Level',
    iconName: 'align-left',
    route: 'mnlvl1',
    children: [
      {
        displayName: 'Level-1',
        iconName: 'coffee',
        route: 'mnlvl1/mnlvl1-1',
        children: [
          {
            displayName: 'Page1',
            iconName: 'disc',
            route: 'mnlvl1/mnlvl1-1/page1',
          },
          {
            displayName: 'Page2',
            iconName: 'disc',
            route: 'mnlvl1/mnlvl1-1/page2',
          },
          {
            displayName: 'Page3',
            iconName: 'disc',
            route: 'mnlvl1/mnlvl1-1/page3',
          },
        ],
      },
      {
        displayName: 'Page Level-1',
        iconName: 'coffee',
        route: 'mnlvl1/pglvl1-1',
        children: [
          {
            displayName: 'Page Level 2',
            iconName: 'coffee',
            route: 'mnlvl1/pglvl1-1/mnlvl2',
          },
        ],
      },
    ],
  },
];
